var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoletoEExtratoSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 90,
  height: 88,
  viewBox: "0 0 90 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_8933_65330)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M45.0003 24.6667C32.1203 24.6667 21.667 35.1201 21.667 48.0001C21.667 60.8801 32.1203 71.3334 45.0003 71.3334C57.8803 71.3334 68.3337 60.8801 68.3337 48.0001C68.3337 35.1201 57.8803 24.6667 45.0003 24.6667ZM45.0003 66.6667C34.7103 66.6667 26.3337 58.2901 26.3337 48.0001C26.3337 37.7101 34.7103 29.3334 45.0003 29.3334C55.2903 29.3334 63.667 37.7101 63.667 48.0001C63.667 58.2901 55.2903 66.6667 45.0003 66.6667ZM47.077 45.9001C42.9237 44.5234 40.917 43.6601 40.917 41.4667C40.917 39.0867 43.507 38.2234 45.1403 38.2234C48.197 38.2234 49.317 40.5334 49.5737 41.3501L53.2603 39.7867C52.9103 38.7601 51.347 35.3301 47.0537 34.5834V31.6667H42.9703V34.6067C36.9037 35.9134 36.857 41.2567 36.857 41.5134C36.857 46.8101 42.107 48.3034 44.6737 49.2367C48.3603 50.5434 49.9937 51.7334 49.9937 53.9734C49.9937 56.6101 47.5437 57.7301 45.3737 57.7301C41.127 57.7301 39.9137 53.3667 39.7737 52.8534L35.9003 54.4167C37.3703 59.5267 41.2203 60.9034 42.947 61.3234V64.3334H47.0303V61.4401C48.2437 61.2301 54.077 60.0634 54.077 53.9267C54.1003 50.6834 52.677 47.8367 47.077 45.9001Z",
  fill: "#86AA63"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.07004 10.1803C5.44132 10.1803 3.30989 12.1864 3.30989 14.6611L0 83.5197C0 85.9943 2.13143 88 4.76016 88H84.3125C86.9417 88 89.0732 85.9943 89.0732 83.5197L84.816 4.48079C84.816 2.00614 82.6846 0 80.0554 0L8.07004 10.1803Z",
  fill: "#162C2B",
  fillOpacity: 0.05
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_8933_65330"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 56,
  fill: "white",
  transform: "translate(17 20)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoletoEExtratoSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boleto_e_extrato_sensia.8b57d4a28aba55397de148037f0f9ec4.svg";